import { Component, OnChanges } from '@angular/core';
import * as _ from 'lodash';
import { BaseSegmentComponent } from '../base/_base-segment.component';
import { SortableService } from 'shared/sortable/sortable.service';

@Component({
  moduleId: module.id,
  selector: 'kits-segment',
  templateUrl: 'kits.component.html',
  styleUrls: ['kits.component.scss'],
  providers: [SortableService]
})
export class KitsComponent extends BaseSegmentComponent implements OnChanges {
  headers: any[] = [
  'component_part_number.value',
  'description.value',
  'quantity_in_kit.quantity',
  'quantity_in_kit.uom',
  'sold_separately',
  ];

  kits: any[] = [];

  ngOnChanges() {
    if (this.itemDetail && this.itemDetail.kits) {
      this.kits = [...this.itemDetail.kits];
    }
    this.setItemsErrorMark(this.data, this.kits, 'kits');
    this.data = _.filter(this.orderBy(this.data, 'sequence'), (item: any) => {
      return _.includes(this.headers, item.item_name);
    });
  }
}
